import { render, staticRenderFns } from "./AppraiserType.vue?vue&type=template&id=77dfc581&"
import script from "./AppraiserType.vue?vue&type=script&lang=js&"
export * from "./AppraiserType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports